/** @Deprecated: consider to remove it because it seems it is not used anymore */
hrd.validation = {
	integer: function(value){
		return this._test_('^[0-9]+$', value);
	},
	/*
	 * Numero reale con 2 decimali obbligatori
	 */
	amount: function(value){
		return this._test_('^[0-9]+(,[0-9]{2,2})*$', value);
	},
	/*
	 * Numero reale con 2 decimali e max 100
	 */
	percentage: function(value){
		return this._test_('^(0|[1-9]\\d?)(,\\d{1,2})*$|100,00$', value);
	},
	_test_: function(re, value){
		return new RegExp(re).test(value);
	}
};